module.exports = __webpack_public_path__ + "img/qm5.eb716416.jpg";